import { render, staticRenderFns } from "./crownTaskDropdown.vue?vue&type=template&id=31668547&scoped=true&"
import script from "./crownTaskDropdown.vue?vue&type=script&lang=js&"
export * from "./crownTaskDropdown.vue?vue&type=script&lang=js&"
import style0 from "./crownDropdown.scss?vue&type=style&index=0&id=31668547&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31668547",
  null
  
)

export default component.exports